import eran from './img/family/eran.jpg';
import eti from './img/family/eti.jpg';
import jacob from './img/family/jacob.jpg';
import kfir from './img/family/kfir.jpg';
import nehama from './img/family/nehama.jpg';
import ori from './img/family/ori.jpg';

import rotem from './img/family/rotem.jpg';
import shir from './img/family/shir.jpg';
import sigal from './img/family/sigal.jpg';
import tali from './img/family/tali.jpg';
import kobi from './img/family/kobi.jpg';
import karmit from './img/family/karmit.jpg';
import edna from './img/family/edna.jpg';
import itzik from './img/family/itzik.jpg';
import yaron from './img/family/yaron.jpg';
import noya from './img/family/noya.jpg';
import dor from './img/family/dor.jpg';
import tavor from './img/family/tavor.jpg';
import yonatan from './img/family/yonatan.jpg';
import hadas from './img/family/hadas.jpg';
import hana from './img/family/hana.jpg';
import david from './img/family/david.jpg';
import yhoda from './img/family/yhoda.jpg';
import maxine from './img/family/maxine.jpg';
import menahem from './img/family/menahem_miller.jpeg';
import rosa from './img/family/rosa_miller.jpeg';
import yosefZion from './img/family/yosef_zion.jpeg';
import rahelZion from './img/family/rahel_zion.jpg';
import mosheZion from './img/family/moshe_zion.jpg';

export const familyTreeData = [
    {
        id: "0",
        rels: {
            spouses: [
                "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a"
            ],
            children: [
                "e5d0e68e-3ffd-4734-9bec-ead7185ac071",
                "fc4f1120-e4f8-4260-9ab6-fddb89db206c",
                "f802cac5-a4a6-4b0d-8d7e-92d98f63a545"
            ],
            father: "92a97179-411d-49e3-9f81-0a24ec00a4fb",
            mother: "e17e1785-377c-4bb8-a292-949700d3c49e"
        },
        data: {
            firstName: "כפיר",
            lastName: "מילר",
            birthday: "1980",
            birthDate: "09-30",
            anniversaryDate: "10-13",
            anniversaryYear: "2010",
            spouseName: "סיגל",
            avatar: kfir,
            gender: "M"
        }
    },
    {
        id: "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a",
        data: {
            gender: "F",
            firstName: "סיגל",
            lastName: "מילר",
            birthday: "1982",
            birthDate: "04-29",
            avatar: sigal
        },
        rels: {
            spouses: [
                "0"
            ],
            children: [
                "e5d0e68e-3ffd-4734-9bec-ead7185ac071",
                "fc4f1120-e4f8-4260-9ab6-fddb89db206c",
                "f802cac5-a4a6-4b0d-8d7e-92d98f63a545"
            ],
            mother: "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
            father: "7db200bd-1b81-426a-ab94-cb0d5adead22"
        }
    },
    {
        id: "e5d0e68e-3ffd-4734-9bec-ead7185ac071",
        data: {
            gender: "M",
            firstName: "אורי",
            lastName: "מילר",
            birthday: "2023",
            birthDate: "08-24",
            avatar: ori
        },
        rels: {
            father: "0",
            mother: "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a"
        }
    },
    {
        id: "fc4f1120-e4f8-4260-9ab6-fddb89db206c",
        data: {
            gender: "F",
            firstName: "שיר",
            lastName: "מילר",
            birthday: "2015",
            birthDate: "09-16",
            avatar: shir
        },
        rels: {
            father: "0",
            mother: "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a"
        }
    },
    {
        id: "f802cac5-a4a6-4b0d-8d7e-92d98f63a545",
        data: {
            gender: "F",
            firstName: "רותם",
            lastName: "מילר",
            birthday: "2012",
            birthDate: "02-15",
            avatar: rotem
        },
        rels: {
            father: "0",
            mother: "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a"
        }
    },
    {
        id: "92a97179-411d-49e3-9f81-0a24ec00a4fb",
        data: {
            gender: "M",
            firstName: "יצחק",
            lastName: "מילר",
            birthday: "1949",
            birthDate: "10-10",
            anniversaryDate: "04-06",
            anniversaryYear: "1971",
            spouseName: "עדנה",
            avatar: itzik
        },
        rels: {
            children: [
                "0",
                "6df9efbc-3481-4a68-9664-42cc56570afe",
                "71293e3f-47fd-4587-806c-76c676380e38"
            ],
            spouses: [
                "e17e1785-377c-4bb8-a292-949700d3c49e"
            ],
            father: "496e709e-fbc4-4d10-9b1f-8fc59f8c8707",
            mother: "f986c987-7e33-4f9f-b6cc-14ee580842cb"
        }
    },
    {
        id: "e17e1785-377c-4bb8-a292-949700d3c49e",
        data: {
            gender: "F",
            firstName: "עדנה",
            lastName: "מילר",
            birthday: "1951",
            birthDate: "11-15",
            anniversaryDate: "04-06",
            anniversaryYear: "1971",
            spouseName: "יצחק",
            avatar: edna
        },
        rels: {
            children: [
                "0",
                "6df9efbc-3481-4a68-9664-42cc56570afe",
                "71293e3f-47fd-4587-806c-76c676380e38"
            ],
            spouses: [
                "92a97179-411d-49e3-9f81-0a24ec00a4fb"
            ],
            mother: "ea6ecab8-5737-47c8-b98c-061b6dd9460b",
            father: "183ab44e-7fc8-480f-96f5-6ba8556c8962"
        }
    },
    {
        id: "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
        data: {
            gender: "F",
            firstName: "נחמה",
            lastName: "פרוסט",
            birthday: "1953",
            birthDate: "11-21",
            spouseName: "יעקוב",
            avatar: nehama
        },
        rels: {
            children: [
                "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a",
                "f37516eb-afd3-4149-bb36-2df396ae591b",
                "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924",
                "8fd3c55a-2abf-4e45-8e4d-afa8e4eae63c"
            ],
            spouses: [
                "7db200bd-1b81-426a-ab94-cb0d5adead22"
            ],
            father: "nehama-father-001",
            mother: "nehama-mother-001"
        }
    },
    {
        id: "nehama-father-001",
        data: {
            gender: "M",
            firstName: "אב",
            lastName: "מנחם",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
                "haya-flint-001"
            ],
            spouses: [
                "nehama-mother-001"
            ]
        }
    },
    {
        id: "nehama-mother-001",
        data: {
            gender: "F",
            firstName: "אם",
            lastName: "מנחם",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
                "haya-flint-001"
            ],
            spouses: [
                "nehama-father-001"
            ]
        }
    },
    {
        id: "haya-flint-001",
        data: {
            gender: "F",
            firstName: "חיה",
            lastName: "פלינט",
            birthday: "1953",
            birthDate: "11-21",
            avatar: ""
        },
        rels: {
            father: "nehama-father-001",
            mother: "nehama-mother-001"
        }
    },
    {
        id: "7db200bd-1b81-426a-ab94-cb0d5adead22",
        data: {
            gender: "M",
            firstName: "יעקוב",
            lastName: "פרוסט",
            birthday: "1955",
            birthDate: "10-08",
            spouseName: "נחמה",
            avatar: jacob
        },
        rels: {
            children: [
                "7a40f6ac-fbf9-40f0-aa9c-0c95bf15536a",
                "f37516eb-afd3-4149-bb36-2df396ae591b",
                "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924",
                "8fd3c55a-2abf-4e45-8e4d-afa8e4eae63c"
            ],
            spouses: [
                "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c"
            ]
        }
    },
    {
        id: "496e709e-fbc4-4d10-9b1f-8fc59f8c8707",
        data: {
            gender: "M",
            firstName: "מנחם",
            lastName: "מילר",
            birthday: "1917",
            birthDate: "03-25",
            birthPlace: "לודז', פולין",
            deathYear: "1993",
            memorialDate: "04-16",
            avatar: menahem
        },
        rels: {
            children: [
                "92a97179-411d-49e3-9f81-0a24ec00a4fb",
                "5e2b79dd-4697-4405-805e-27f8e4f09064"
            ],
            spouses: [
                "f986c987-7e33-4f9f-b6cc-14ee580842cb"
            ],
            father: "31e0ddad-d3e0-435c-9752-221f113c4478",
            mother: "a9d28f44-6842-4b77-84ff-cb2332cf980b"
        }
    },
    {
        id: "f986c987-7e33-4f9f-b6cc-14ee580842cb",
        data: {
            gender: "F",
            firstName: "רוזה (רושקה)",
            lastName: "מילר",
            birthday: "1921",
            birthDate: "08-21",
            birthPlace: "לודז', פולין",
            maidenName: "ברגמן",
            deathYear: "1995",
            deathPlace: "חיפה, ישראל",
            memorialDate: "07-21",
            avatar: rosa
        },
        rels: {
            children: [
                "92a97179-411d-49e3-9f81-0a24ec00a4fb",
                "5e2b79dd-4697-4405-805e-27f8e4f09064"
            ],
            spouses: [
                "496e709e-fbc4-4d10-9b1f-8fc59f8c8707"
            ]
        }
    },
    {
        id: "f37516eb-afd3-4149-bb36-2df396ae591b",
        data: {
            gender: "M",
            firstName: "רועי",
            lastName: "פרוסט",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
            mother: "7db200bd-1b81-426a-ab94-cb0d5adead22",
            spouses: [
                "2751d76d-7fff-40e1-8d07-e9486a312546"
            ],
            children: [
                "f793a4e4-9d8a-4f83-bc26-fa01e4f527aa"
            ]
        }
    },
    {
        id: "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924",
        data: {
            gender: "F",
            firstName: "טלי",
            lastName: "צדוק",
            birthday: "1975",
            birthDate: "12-25",
            anniversaryDate: "10-10",
            anniversaryYear: "2001",
            spouseName: "ערן",
            avatar: tali
        },
        rels: {
            father: "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
            mother: "7db200bd-1b81-426a-ab94-cb0d5adead22",
            spouses: [
                "135e94f9-2af0-45ec-921b-d6cd7e06d681"
            ],
            children: [
                "e0247516-241c-4fd4-ad36-084611cdc67c",
                "8dbae0a4-e6c2-4b30-a5ed-fd0a53433b4a",
                "48d30704-281f-4f2e-8e9e-3141cf3998bc"
            ]
        }
    },
    {
        id: "8fd3c55a-2abf-4e45-8e4d-afa8e4eae63c",
        data: {
            gender: "F",
            firstName: "אתי",
            lastName: "כהן",
            birthday: "1974",
            birthDate: "06-21",
            avatar: eti
        },
        rels: {
            father: "7db200bd-1b81-426a-ab94-cb0d5adead22",
            mother: "c695fe79-eaa2-4a9c-a44e-f2fdcd17555c",
            spouses: [
                "191752fc-ece0-4941-8726-f9fa3f1307ef"
            ],
            children: [
                "9bce4c33-5a29-4993-97d4-3db7483f4eb7",
                "56374a82-a198-43b5-943b-1f294f354ef8"
            ]
        }
    },
    {
        id: "6df9efbc-3481-4a68-9664-42cc56570afe",
        data: {
            gender: "M",
            firstName: "קובי",
            lastName: "מילר",
            birthday: "1973",
            birthDate: "04-28",
            anniversaryDate: "05-28",
            anniversaryYear: "2002",
            spouseName: "הדס",
            avatar: kobi
        },
        rels: {
            father: "92a97179-411d-49e3-9f81-0a24ec00a4fb",
            mother: "e17e1785-377c-4bb8-a292-949700d3c49e",
            spouses: [
                "178dddf8-2c86-48dd-ab44-c45bc2f44bb9"
            ],
            children: [
                "fbeb5ffd-a894-4fef-95ba-292cad64b24c",
                "252c04ff-219d-4247-ae0c-5747cf700a7b"
            ]
        }
    },
    {
        id: "71293e3f-47fd-4587-806c-76c676380e38",
        data: {
            gender: "F",
            firstName: "כרמית",
            lastName: "בולקיה",
            birthday: "1974",
            birthDate: "08-21",
            anniversaryDate: "03-06",
            anniversaryYear: "2008",
            spouseName: "ירון",
            avatar: karmit
        },
        rels: {
            father: "92a97179-411d-49e3-9f81-0a24ec00a4fb",
            mother: "e17e1785-377c-4bb8-a292-949700d3c49e",
            spouses: [
                "7c4661d9-b1ff-4719-8273-3cb436ba632b"
            ],
            children: [
                "cf26687b-f7c4-4e71-b586-8f064afda852",
                "8fc9e027-95b2-4f19-b496-005c4cb87691"
            ]
        }
    },
    {
        id: "178dddf8-2c86-48dd-ab44-c45bc2f44bb9",
        data: {
            gender: "F",
            firstName: "הדס",
            lastName: "מילר",
            birthday: "1977",
            birthDate: "10-07",
            anniversaryDate: "05-28",
            anniversaryYear: "2002",
            spouseName: "קובי",
            avatar: hadas
        },
        rels: {
            spouses: [
                "6df9efbc-3481-4a68-9664-42cc56570afe"
            ],
            children: [
                "fbeb5ffd-a894-4fef-95ba-292cad64b24c",
                "252c04ff-219d-4247-ae0c-5747cf700a7b"
            ]
        }
    },
    {
        id: "fbeb5ffd-a894-4fef-95ba-292cad64b24c",
        data: {
            gender: "M",
            firstName: "דור",
            lastName: "מילר",
            birthday: "2009",
            birthDate: "01-24",
            avatar: dor
        },
        rels: {
            father: "6df9efbc-3481-4a68-9664-42cc56570afe",
            mother: "178dddf8-2c86-48dd-ab44-c45bc2f44bb9"
        }
    },
    {
        id: "252c04ff-219d-4247-ae0c-5747cf700a7b",
        data: {
            gender: "M",
            firstName: "תבור",
            lastName: "מילר",
            birthday: "2015",
            birthDate: "08-25",
            avatar: tavor
        },
        rels: {
            father: "178dddf8-2c86-48dd-ab44-c45bc2f44bb9",
            mother: "6df9efbc-3481-4a68-9664-42cc56570afe"
        }
    },
    {
        id: "7c4661d9-b1ff-4719-8273-3cb436ba632b",
        data: {
            gender: "M",
            firstName: "ירון",
            lastName: "בולקיה",
            birthday: "1973",
            birthDate: "12-02",
            anniversaryDate: "03-06",
            anniversaryYear: "2008",
            spouseName: "כרמית",
            avatar: yaron
        },
        rels: {
            spouses: [
                "71293e3f-47fd-4587-806c-76c676380e38"
            ],
            children: [
                "cf26687b-f7c4-4e71-b586-8f064afda852",
                "8fc9e027-95b2-4f19-b496-005c4cb87691"
            ]
        }
    },
    {
        id: "cf26687b-f7c4-4e71-b586-8f064afda852",
        data: {
            gender: "F",
            firstName: "נויה",
            lastName: "בולקיה",
            birthday: "2014",
            birthDate: "02-12",
            avatar: noya
        },
        rels: {
            father: "71293e3f-47fd-4587-806c-76c676380e38",
            mother: "7c4661d9-b1ff-4719-8273-3cb436ba632b"
        }
    },
    {
        id: "8fc9e027-95b2-4f19-b496-005c4cb87691",
        data: {
            gender: "M",
            firstName: "יונתן",
            lastName: "בולקיה",
            birthday: "2009",
            birthDate: "05-05",
            avatar: yonatan
        },
        rels: {
            father: "71293e3f-47fd-4587-806c-76c676380e38",
            mother: "7c4661d9-b1ff-4719-8273-3cb436ba632b"
        }
    },
    {
        id: "31e0ddad-d3e0-435c-9752-221f113c4478",
        data: {
            gender: "M",
            firstName: "יעקוב",
            lastName: "מילר",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "496e709e-fbc4-4d10-9b1f-8fc59f8c8707",
                "fd7a9177-005f-46ec-85a3-800c07d1da9a"
            ],
            spouses: [
                "a9d28f44-6842-4b77-84ff-cb2332cf980b"
            ]
        }
    },
    {
        id: "a9d28f44-6842-4b77-84ff-cb2332cf980b",
        data: {
            gender: "F",
            firstName: "לאה",
            lastName: "מילר",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "496e709e-fbc4-4d10-9b1f-8fc59f8c8707",
                "fd7a9177-005f-46ec-85a3-800c07d1da9a"
            ],
            spouses: [
                "31e0ddad-d3e0-435c-9752-221f113c4478"
            ]
        }
    },
    {
        id: "fd7a9177-005f-46ec-85a3-800c07d1da9a",
        data: {
            gender: "F",
            firstName: "אסתר",
            lastName: "מילר",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "31e0ddad-d3e0-435c-9752-221f113c4478",
            mother: "a9d28f44-6842-4b77-84ff-cb2332cf980b"
        }
    },
    {
        id: "ea6ecab8-5737-47c8-b98c-061b6dd9460b",
        data: {
            gender: "F",
            firstName: "רחל",
            lastName: "ציון",
            birthday: "1922",
            birthPlace: "חיפה, ישראל",
            maidenName: "ספורטס",
            deathYear: "1996",
            memorialDate: "09-25",
            deathPlace: "חיפה, ישראל",
            avatar: rahelZion
        },
        rels: {
            children: [
                "e17e1785-377c-4bb8-a292-949700d3c49e",
                "cbd2c119-caa3-416d-98a5-8ba508d982aa",
                "66054536-49dc-415a-992b-9f17b2f08853",
                "272f2be9-9004-4ea2-9c05-62273a82c80d"
            ],
            spouses: [
                "183ab44e-7fc8-480f-96f5-6ba8556c8962"
            ]
        }
    },
    {
        id: "183ab44e-7fc8-480f-96f5-6ba8556c8962",
        data: {
            gender: "M",
            firstName: "יוסף",
            lastName: "ציון",
            birthday: "1912",
            birthPlace: "ירושלים, ישראל",
            deathYear: "1988",
            memorialDate: "06-22",
            deathPlace: "חיפה, ישראל",
            avatar: yosefZion
        },
        rels: {
            children: [
                "e17e1785-377c-4bb8-a292-949700d3c49e",
                "cbd2c119-caa3-416d-98a5-8ba508d982aa",
                "66054536-49dc-415a-992b-9f17b2f08853",
                "272f2be9-9004-4ea2-9c05-62273a82c80d"
            ],
            spouses: [
                "ea6ecab8-5737-47c8-b98c-061b6dd9460b"
            ],
            father: "d989bf38-07cc-41ae-8d6f-b95161cf191b",
            mother: "8b3341a2-f517-4521-8d04-40d49e5f3437"
        }
    },
    {
        id: "d989bf38-07cc-41ae-8d6f-b95161cf191b",
        data: {
            gender: "M",
            firstName: "משה",
            lastName: "ציון",
            birthday: "1853 - 1948",
            memorialDate: "02-20",
            avatar: mosheZion
        },
        rels: {
            children: [
                "183ab44e-7fc8-480f-96f5-6ba8556c8962"
            ],
            spouses: [
                "8b3341a2-f517-4521-8d04-40d49e5f3437"
            ],
            father: "1a2c1f48-ad1e-4b52-93c9-d37565fab16c",
            mother: "ef0d99eb-e6d9-4694-b51a-988fec3dc8be"
        }
    },
    {
        id: "8b3341a2-f517-4521-8d04-40d49e5f3437",
        data: {
            gender: "F",
            firstName: "דינה",
            lastName: "ציון (אלג׳ם)",
            birthday: "1892 - 1926",
            memorialDate: "08-14",
            avatar: ""
        },
        rels: {
            children: [
                "183ab44e-7fc8-480f-96f5-6ba8556c8962"
            ],
            spouses: [
                "d989bf38-07cc-41ae-8d6f-b95161cf191b"
            ],
            father: "68462168-b588-4e46-bd97-55a384b96ac4",
            mother: "625df122-0dde-4e44-a13a-e43bbfc86108"
        }
    },
    {
        id: "cbd2c119-caa3-416d-98a5-8ba508d982aa",
        data: {
            gender: "M",
            firstName: "משה",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "ea6ecab8-5737-47c8-b98c-061b6dd9460b",
            mother: "183ab44e-7fc8-480f-96f5-6ba8556c8962",
            spouses: [
                "a95ff342-5c28-4b26-a892-c0714e42420f"
            ],
            children: [
                "648bf4da-2527-41c9-a291-4a835410a28f",
                "13f00139-bf07-43ca-a286-2922812b4f87"
            ]
        }
    },
    {
        id: "66054536-49dc-415a-992b-9f17b2f08853",
        data: {
            gender: "M",
            firstName: "דוד",
            lastName: "ציון",
            birthday: "1948",
            birthDate: "01-28",
            deathYear: "2025",
            deathDate: "03-20",
            avatar: david
        },
        rels: {
            father: "183ab44e-7fc8-480f-96f5-6ba8556c8962",
            mother: "ea6ecab8-5737-47c8-b98c-061b6dd9460b",
            spouses: [
                "1cc04ecb-0b86-4a5a-a3a2-7eeb6d39943b"
            ],
            children: [
                "09094a8d-ce91-4b97-90cd-70b5e126fb2b",
                "4cbe5ee5-2a51-4037-8ae5-b028adbc5b27"
            ]
        }
    },
    {
        id: "272f2be9-9004-4ea2-9c05-62273a82c80d",
        data: {
            gender: "M",
            firstName: "יהודה",
            lastName: "ציון",
            birthday: "1946",
            birthDate: "03-11",
            avatar: yhoda
        },
        rels: {
            father: "183ab44e-7fc8-480f-96f5-6ba8556c8962",
            mother: "ea6ecab8-5737-47c8-b98c-061b6dd9460b",
            spouses: [
                "a07b23b4-5af5-418c-87fe-4899b49f70ec"
            ],
            children: [
                "2ac9868b-5fe1-40c6-a1df-0b8b6dd77993",
                "0ceae74c-790c-4453-b1f0-d6ed7013181c"
            ]
        }
    },
    {
        id: "191752fc-ece0-4941-8726-f9fa3f1307ef",
        data: {
            gender: "M",
            firstName: "אלי",
            lastName: "כהן",
            birthday: "1973",
            birthDate: "11-12",
            avatar: ""
        },
        rels: {
            spouses: [
                "8fd3c55a-2abf-4e45-8e4d-afa8e4eae63c"
            ],
            children: [
                "9bce4c33-5a29-4993-97d4-3db7483f4eb7",
                "56374a82-a198-43b5-943b-1f294f354ef8"
            ]
        }
    },
    {
        id: "9bce4c33-5a29-4993-97d4-3db7483f4eb7",
        data: {
            gender: "F",
            firstName: "מיה",
            lastName: "כהן",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "8fd3c55a-2abf-4e45-8e4d-afa8e4eae63c",
            mother: "191752fc-ece0-4941-8726-f9fa3f1307ef"
        }
    },
    {
        id: "56374a82-a198-43b5-943b-1f294f354ef8",
        data: {
            gender: "F",
            firstName: "רומי",
            lastName: "כהן",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "8fd3c55a-2abf-4e45-8e4d-afa8e4eae63c",
            mother: "191752fc-ece0-4941-8726-f9fa3f1307ef"
        }
    },
    {
        id: "135e94f9-2af0-45ec-921b-d6cd7e06d681",
        data: {
            gender: "M",
            firstName: "ערן",
            lastName: "צדוק",
            birthday: "1983",
            birthDate: "03-30",
            avatar: eran
        },
        rels: {
            spouses: [
                "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924"
            ],
            children: [
                "e0247516-241c-4fd4-ad36-084611cdc67c",
                "8dbae0a4-e6c2-4b30-a5ed-fd0a53433b4a",
                "48d30704-281f-4f2e-8e9e-3141cf3998bc"
            ]
        }
    },
    {
        id: "e0247516-241c-4fd4-ad36-084611cdc67c",
        data: {
            gender: "M",
            firstName: "איתי",
            lastName: "צדוק",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "135e94f9-2af0-45ec-921b-d6cd7e06d681",
            mother: "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924"
        }
    },
    {
        id: "8dbae0a4-e6c2-4b30-a5ed-fd0a53433b4a",
        data: {
            gender: "F",
            firstName: "אליה",
            lastName: "צדוק",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "135e94f9-2af0-45ec-921b-d6cd7e06d681",
            mother: "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924"
        }
    },
    {
        id: "48d30704-281f-4f2e-8e9e-3141cf3998bc",
        data: {
            gender: "F",
            firstName: "עלמה",
            lastName: "צדוק",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "c2e8a9e8-c45f-4f65-ad9b-a6cd35c19924",
            mother: "135e94f9-2af0-45ec-921b-d6cd7e06d681"
        }
    },
    {
        id: "2751d76d-7fff-40e1-8d07-e9486a312546",
        data: {
            gender: "F",
            firstName: "ליה",
            lastName: "פרוסט",
            birthday: "",
            avatar: ""
        },
        rels: {
            spouses: [
                "f37516eb-afd3-4149-bb36-2df396ae591b"
            ],
            children: [
                "f793a4e4-9d8a-4f83-bc26-fa01e4f527aa"
            ]
        }
    },
    {
        id: "f793a4e4-9d8a-4f83-bc26-fa01e4f527aa",
        data: {
            gender: "M",
            firstName: "אדם",
            lastName: "פרוסט",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "f37516eb-afd3-4149-bb36-2df396ae591b",
            mother: "2751d76d-7fff-40e1-8d07-e9486a312546"
        }
    },
    {
        id: "a95ff342-5c28-4b26-a892-c0714e42420f",
        data: {
            gender: "F",
            firstName: "מקסין",
            lastName: "ציון",
            birthday: "",
            avatar: maxine
        },
        rels: {
            spouses: [
                "cbd2c119-caa3-416d-98a5-8ba508d982aa"
            ],
            children: [
                "648bf4da-2527-41c9-a291-4a835410a28f",
                "13f00139-bf07-43ca-a286-2922812b4f87"
            ]
        }
    },
    {
        id: "648bf4da-2527-41c9-a291-4a835410a28f",
        data: {
            gender: "F",
            firstName: "ג׳ודי",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "cbd2c119-caa3-416d-98a5-8ba508d982aa",
            mother: "a95ff342-5c28-4b26-a892-c0714e42420f"
        }
    },
    {
        id: "13f00139-bf07-43ca-a286-2922812b4f87",
        data: {
            gender: "M",
            firstName: "הארי",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "cbd2c119-caa3-416d-98a5-8ba508d982aa",
            mother: "a95ff342-5c28-4b26-a892-c0714e42420f"
        }
    },
    {
        id: "1cc04ecb-0b86-4a5a-a3a2-7eeb6d39943b",
        data: {
            gender: "F",
            firstName: "עדנה",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            spouses: [
                "66054536-49dc-415a-992b-9f17b2f08853"
            ],
            children: [
                "09094a8d-ce91-4b97-90cd-70b5e126fb2b",
                "4cbe5ee5-2a51-4037-8ae5-b028adbc5b27"
            ]
        }
    },
    {
        id: "09094a8d-ce91-4b97-90cd-70b5e126fb2b",
        data: {
            gender: "F",
            firstName: "נועה",
            lastName: "ציון",
            birthday: "1981",
            birthDate: "03-21",
            avatar: ""
        },
        rels: {
            father: "66054536-49dc-415a-992b-9f17b2f08853",
            mother: "1cc04ecb-0b86-4a5a-a3a2-7eeb6d39943b"
        }
    },
    {
        id: "4cbe5ee5-2a51-4037-8ae5-b028adbc5b27",
        data: {
            gender: "F",
            firstName: "מירב",
            lastName: "ציון",
            birthday: "1986",
            birthDate: "01-18",
            avatar: ""
        },
        rels: {
            father: "1cc04ecb-0b86-4a5a-a3a2-7eeb6d39943b",
            mother: "66054536-49dc-415a-992b-9f17b2f08853"
        }
    },
    {
        id: "a07b23b4-5af5-418c-87fe-4899b49f70ec",
        data: {
            gender: "F",
            firstName: "מרלין",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            spouses: [
                "272f2be9-9004-4ea2-9c05-62273a82c80d"
            ],
            children: [
                "2ac9868b-5fe1-40c6-a1df-0b8b6dd77993",
                "0ceae74c-790c-4453-b1f0-d6ed7013181c"
            ]
        }
    },
    {
        id: "2ac9868b-5fe1-40c6-a1df-0b8b6dd77993",
        data: {
            gender: "M",
            firstName: "אמיר",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "272f2be9-9004-4ea2-9c05-62273a82c80d",
            mother: "a07b23b4-5af5-418c-87fe-4899b49f70ec"
        }
    },
    {
        id: "0ceae74c-790c-4453-b1f0-d6ed7013181c",
        data: {
            gender: "F",
            firstName: "חלי",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "272f2be9-9004-4ea2-9c05-62273a82c80d",
            mother: "a07b23b4-5af5-418c-87fe-4899b49f70ec"
        }
    },
    {
        id: "1a2c1f48-ad1e-4b52-93c9-d37565fab16c",
        data: {
            gender: "M",
            firstName: "אברהם",
            lastName: "ציון",
            birthday: "1829 - 1907",
            avatar: ""
        },
        rels: {
            children: [
                "d989bf38-07cc-41ae-8d6f-b95161cf191b"
            ],
            spouses: [
                "ef0d99eb-e6d9-4694-b51a-988fec3dc8be"
            ],
            mother: "8464dd54-64ee-43e1-95e3-a03f36054544",
            father: "ca09dcfa-2768-4182-b61d-9522126624e3"
        }
    },
    {
        id: "ef0d99eb-e6d9-4694-b51a-988fec3dc8be",
        data: {
            gender: "F",
            firstName: "לאה",
            lastName: "ציון",
            birthday: "1837 - 1913",
            avatar: ""
        },
        rels: {
            children: [
                "d989bf38-07cc-41ae-8d6f-b95161cf191b"
            ],
            spouses: [
                "1a2c1f48-ad1e-4b52-93c9-d37565fab16c"
            ],
            mother: "59ad5a5f-077f-4f53-b4a3-6fe1b213d2de",
            father: "04e97086-7d1c-4cf9-95a3-c0d07c123ffd"
        }
    },
    {
        id: "68462168-b588-4e46-bd97-55a384b96ac4",
        data: {
            gender: "M",
            firstName: "דוד",
            lastName: "אלג׳ם",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "8b3341a2-f517-4521-8d04-40d49e5f3437",
                "ffe36575-c550-44e0-8581-e8245cf1f171"
            ],
            spouses: [
                "625df122-0dde-4e44-a13a-e43bbfc86108"
            ]
        }
    },
    {
        id: "625df122-0dde-4e44-a13a-e43bbfc86108",
        data: {
            gender: "F",
            firstName: "רחל",
            lastName: "אלג׳ם",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "8b3341a2-f517-4521-8d04-40d49e5f3437",
                "ffe36575-c550-44e0-8581-e8245cf1f171"
            ],
            spouses: [
                "68462168-b588-4e46-bd97-55a384b96ac4"
            ]
        }
    },
    {
        id: "ffe36575-c550-44e0-8581-e8245cf1f171",
        data: {
            gender: "F",
            firstName: "מזל",
            lastName: "אלג׳ם",
            birthday: "1898",
            deathYear: "1982",
            avatar: ""
        },
        rels: {
            father: "625df122-0dde-4e44-a13a-e43bbfc86108",
            mother: "68462168-b588-4e46-bd97-55a384b96ac4"
        }
    },
    {
        id: "59ad5a5f-077f-4f53-b4a3-6fe1b213d2de",
        data: {
            gender: "F",
            firstName: "באייה",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "ef0d99eb-e6d9-4694-b51a-988fec3dc8be"
            ],
            spouses: [
                "04e97086-7d1c-4cf9-95a3-c0d07c123ffd"
            ]
        }
    },
    {
        id: "04e97086-7d1c-4cf9-95a3-c0d07c123ffd",
        data: {
            gender: "M",
            firstName: "יהודה",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "ef0d99eb-e6d9-4694-b51a-988fec3dc8be"
            ],
            spouses: [
                "59ad5a5f-077f-4f53-b4a3-6fe1b213d2de"
            ]
        }
    },
    {
        id: "8464dd54-64ee-43e1-95e3-a03f36054544",
        data: {
            gender: "F",
            firstName: "ונדורה",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "1a2c1f48-ad1e-4b52-93c9-d37565fab16c"
            ],
            spouses: [
                "ca09dcfa-2768-4182-b61d-9522126624e3"
            ]
        }
    },
    {
        id: "ca09dcfa-2768-4182-b61d-9522126624e3",
        data: {
            gender: "M",
            firstName: "משה",
            lastName: "ציון",
            birthday: "",
            avatar: ""
        },
        rels: {
            children: [
                "1a2c1f48-ad1e-4b52-93c9-d37565fab16c"
            ],
            spouses: [
                "8464dd54-64ee-43e1-95e3-a03f36054544"
            ]
        }
    },
    {
        id: "5e2b79dd-4697-4405-805e-27f8e4f09064",
        data: {
            gender: "F",
            firstName: "חנה",
            lastName: "לבקוביץ",
            birthday: "",
            avatar: hana
        },
        rels: {
            father: "f986c987-7e33-4f9f-b6cc-14ee580842cb",
            mother: "496e709e-fbc4-4d10-9b1f-8fc59f8c8707",
            spouses: [
                "fdbdaed9-4c37-4da2-a963-75ef1c4a6287"
            ],
            children: [
                "5434f5a3-4e3a-45e0-87c8-f457dc3eca8d",
                "9f8b0d96-293d-4b6c-becc-08176b22bc85"
            ]
        }
    },
    {
        id: "fdbdaed9-4c37-4da2-a963-75ef1c4a6287",
        data: {
            gender: "F",
            firstName: "אברהם",
            lastName: "לבקוביץ",
            birthday: "",
            avatar: ""
        },
        rels: {
            spouses: [
                "5e2b79dd-4697-4405-805e-27f8e4f09064"
            ],
            children: [
                "5434f5a3-4e3a-45e0-87c8-f457dc3eca8d",
                "9f8b0d96-293d-4b6c-becc-08176b22bc85"
            ]
        }
    },
    {
        id: "5434f5a3-4e3a-45e0-87c8-f457dc3eca8d",
        data: {
            gender: "F",
            firstName: "עדנה",
            lastName: "קונטנטה",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "5e2b79dd-4697-4405-805e-27f8e4f09064",
            mother: "fdbdaed9-4c37-4da2-a963-75ef1c4a6287"
        }
    },
    {
        id: "9f8b0d96-293d-4b6c-becc-08176b22bc85",
        data: {
            gender: "M",
            firstName: "יעקוב",
            lastName: "לבקוביץ",
            birthday: "",
            avatar: ""
        },
        rels: {
            father: "5e2b79dd-4697-4405-805e-27f8e4f09064",
            mother: "fdbdaed9-4c37-4da2-a963-75ef1c4a6287"
        }
    }
];